import { withConfirmModal } from 'shared/hocs/withConfirmModal'
import { withLanguage } from 'i18n/utils'

export const withOpngoModal = (urlFromProps = props => props.location.opngo) =>
    compose(
        withLanguage,
        withConfirmModal(
            'map.opngo.title',
            'map.opngo.details',
            'map.opngo.confirm',
            props => window.open(`https://opngo.com/${props.language}${urlFromProps(props)}`, '_blank'),
            'showOpngoModal'
        )
    )
